import { Component } from '@angular/core';


@Component({
	selector: 'finance-awards-tab-2-part',
	standalone: true,
	templateUrl: './finance-awards-tab-2.part.html',
	styleUrls: [`./finance-awards-tab-2.part.scss`],
})
export class FinanceAwardsTab2Part {
}
